export { SORT_TYPES } from './sortTypes';

export const TOAST_SYNC_COLUMNS = [
  { id: 'event_date', label: 'Show Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'event_name', label: 'Event', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'status', label: 'Status', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'toast_item_count', label: 'Items Matched', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'toast_net_sales', label: 'Toast Net Sales', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'pnl_posted', label: 'In P&L', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'business_date', label: 'Business Date', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'date' },
  { id: 'last_synced_at', label: 'Last Synced', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'date' },
  { id: 'actions', label: '', alwaysVisible: false, defaultVisible: true, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  TOAST_SYNC_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  TOAST_SYNC_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
